<template>
    <div class="review">
        <div v-if="store.roles.includes('carEnterprise')" class="addBtn" @click="add"> <a-button type="primary">测试任务发起</a-button></div>
        <a-tabs v-model:activeKey="activeKey">
            <a-tab-pane v-for="item in tabList" :key="item.value" :tab="item.name">
                <div class="query-item">
                    <div class="search-l">
                        <div v-hasRole="['common']" style="margin-right: 30px;">
                            测试主体
                            <a-input class="inp ml24" placeholder="请输入" v-model:value="query.deptName"></a-input>
                        </div>
                        <div>
                            测试牌照
                            <a-input class="inp ml24" placeholder="请输入" v-model:value="query.carTestNum"></a-input>
                        </div>
                        <div class="ml24">
                            测试类型
                            <a-select v-model:value="query.testType" class="inp ml24" placeholder="请输入">
                                <a-select-option value="">全部</a-select-option>
                                <template v-for="item in testType" :key="item.dataCode">
                                    <a-select-option :value="item.dataCode">{{ item.dataValue }}</a-select-option>
                                </template>
                            </a-select>
                        </div>
                        <a-button class="ml24" @click="search" type="primary" ghost>查询</a-button>
                        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
                        <div></div>
                    </div>
                </div>
                <a-table :columns="curColumn" :row-key="(record) => record.id" :data-source="dataSource" class="mt23"
                    size="middle" :pagination="pagination" :scroll="{ x: 1500, y: 'auto' }"
                    v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
                    <template #bodyCell="{ column, record }">
                        <template v-if="column.key === 'createTime'">
                            {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
                        </template>
                        <template v-if="column.key === 'testTime'">
                            {{ record.startTime }} ~ {{ record.endTime }}
                        </template>

                      <template v-if="column.key === 'testType'">
                            {{ getSingleTypeValue(appStore.SysDictVOList,
            'testType' + 'category' + record.testType) }}
                        </template>

                        <template v-if="column.key === 'result'">
                            {{ getStatus(record.endDetailStatus) }}
                        </template>
                        <template v-else-if="column.key === 'action'">
                            <span>
                                <a class="mr10" @click="detail(record)">详情</a>

                                <span v-if="activeKey == -1">
                                    <a @click="audit(record)" v-if="store.hasPermi('test:task:review')">审批</a>
                                    <a class="mr10" v-if="store.hasPermi('test:task:revocation')" @click="revoke(record)">撤销申请</a>
                                </span>
                                <span v-if="activeKey === 0">
                                    <a-popconfirm title="确定结束?" ok-text="确定" cancel-text="取消" @confirm="close(record)">
                                        <a >结束</a>
                                    </a-popconfirm>
                                </span>
                                <span v-if="activeKey === 1">
                                    <a @click="audit(record)">实时监测</a>
                                    <a-popconfirm title="确定结束?" ok-text="确定" cancel-text="取消" @confirm="close(record)">
                                        <a class="mr10">结束</a>
                                    </a-popconfirm>
                                </span>
                                <span v-if="activeKey === 3 && record.status==2">
                                    <a>测试报告</a>
                                </span>
                            </span>
                        </template>
                    </template>
                </a-table>
            </a-tab-pane>
        </a-tabs>

        <reviewModal :modalTitle="'审核'" :modalWidth="'702px'" :isDetailStatus="true" ref="modalRef" @saveEvent="saveEvent">
            <div class="mt32 mb85">
                <div class="radio_class mb26">
                    <span>审核结果：</span>
                    <a-radio-group class="ml26" v-model:value="radioValue">
                        <a-radio :value="1">通过</a-radio>
                        <a-radio :value="0">不通过</a-radio>
                    </a-radio-group>
                </div>

                <div class="radio_class mt22 area_class">
                    审核意见：
                    <a-textarea class="area_width" v-model:value="textAreaValue" placeholder="审批通过时此处非必填"
                        :rows="4" />
                </div>
            </div>
        </reviewModal>



    </div>
</template>
<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, nextTick, computed, watch, onActivated } from 'vue'
import { useRouter, useRoute } from "vue-router";
import reviewModal from '@/components/modal/index.vue'
import uploadButton from '@/components/uploadButton/index.vue'
import useUserStore from '@/store/modules/user'
import useAppStore from "@/store/modules/app";
import { columns, columns2 } from './index.js'
import { getList } from '@/api/enterprise/index.js'
import { taskList,deleteTestTaskAndRels,finishTestTask,approvalTestTask  } from '@/api/test/index.js'
import { getSingleTypeValue } from "@/utils/matchDic.js";
import { message } from 'ant-design-vue';

const router = useRouter();
const appStore = useAppStore();
const store = useUserStore();
const route = useRoute();


const activeKey = ref(-1);
const radioValue = ref(0)
const textAreaValue = ref('')
const textAreaValueJoint = ref('')
const radioValueJoint = ref(0)


const tabList = ref([
    { value: -1, name: '待审批' },
    { value: 0, name: '待测试' },
    { value: 1, name: '测试中' },
    { value: 2, name: '已结束' }
])

let query = reactive({
    carTestNum: "",
    deptName: ""
});

const search = () => {
    pagination.current = 1;
    getData();
};

const reset = () => {
    query.carTestNum = "";
    query.deptName = "";
    // query.status = ""
    pagination.current = 1;
    getData();
};


let curColumn = computed(() => columns.filter(column => column.hidden == false))
if (store.roles.includes('carEnterprise')) {
    curColumn = computed(() => columns2.filter(column => column.hidden == false))
}

watch(() => activeKey.value, val => {
    let targetColumns = store.roles.includes('carEnterprise') ? columns2 : columns;
    let column_temp;
    if (val > -1) {

        column_temp = targetColumns.find((col) => col.key === 'testTime');
        column_temp.hidden = false;
    } else {
        column_temp = targetColumns.find((col) => col.key === 'testTime');
        column_temp.hidden = true;
    }
    if (val == 2) {
        //已结束
        column_temp = targetColumns.find((col) => col.key === 'result');
        column_temp.hidden = false;
    } else {
        column_temp = targetColumns.find((col) => col.key === 'result');
        column_temp.hidden = true;
    }
    curColumn = targetColumns.filter(column => column.hidden === false)
    getData(val);
})


let dataSource = ref([]);

const pagination = reactive({
    total: 0,
    size: "middle",
    defaultPageSize: 10,
    current: 1,
    pageSize: 20, //每页中显示10条数据
    showSizeChanger: true,
    showQuickJumper: false,
    pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
    showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
    onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
    onChange: pageChange, //点击页码事件
    showSizeChange: pageSizeChange,
});

function pageChange(page, pageSize) {
    pagination.current = page;

    // 获取表格数据
    getData();
}

function pageSizeChange(current, size) {
    console.log(size);
    pagination.pageSize = size;

    // 获取表格数据
    getData();
}

function getCompanys() {
    let obj = { "pageIndex": 1, "pageSize": 100, "conditionMap": {} }
    getList().then(res => {
        console.log(res)
    })
}

//结束
function close(row){
    finishTestTask(row.id).then(res=>{
        if(res.code==200){
            message.success('成功')
            getData();
        }
    })
}

function revoke(row){
    deleteTestTaskAndRels(row.id).then(res=>{
        if(res.code==200){
            message.success('成功')
            getData();
        }
    })
}




const getStatus=(val)=>{
    let str='';
    switch(val){
        case 1:
            str = '已测试';
            break;
        case 2:
            str = '超时未测试';
            break;
        case 3:
            str = '超时未审批';
            break;
        case 4:
            str = '审核不通过';
            break;
        default:
            str = '';
            break;
    }
    return str;
}

const getData = () => {
    const data = {
        pageIndex: pagination.current,
        pageSize: pagination.pageSize,
        conditionMap: { ...query },
    };

    activeKey.value==-1?data.conditionMap.approvalStatus=0:data.conditionMap.status=activeKey.value;
    taskList(data).then((res) => {
        res.data.records.map((item, index) => {
            item.ranking = index + 1;
        });
        dataSource.value = res.data.records || [];
        pagination.total = res.data.total;
    });
};

const modalRef = ref()
const modalObjId = ref()
const audit = (record) => {
    console.log(activeKey.value)
    if (activeKey.value === -1) {
        //审批
        modalObjId.value=record.id;
        modalRef.value.showModal()
    }
    if (activeKey.value === 1) {
        console.log(record);
        //实时监测
        router.push({
            path: "/testManage/realtimeMonitorB",
            query: {
                id: record.id
            }
        });
    } else if (activeKey.value === 2) {
        //测试报告
        // router.push({
        //     path: "/testManage/taskDetail",
        //     query: {
        //         status: record.status
        //     }
        // });
    }

}
const saveEvent = () => {
    let obj={
        id:modalObjId.value,
        approvalStatus:radioValue.value,
        approvalMsg:textAreaValue.value
    }
    approvalTestTask(obj).then(res=>{
        if(res.code==200){
            message.success('成功')
            getData();
        }
    })
}


// uploadRef.value.clearFileList()
const uploadFinished = (data) => {
    console.log(data, '111111111');

}

function add() {
    router.push({
        path: "/testManage/testDetail",
        query: {
            activeKey: activeKey.value,
            type: 'edit',
            from: "0"
        }
    });
}

const detail = (record) => {
    console.log(record);
    router.push({
        path: "/testManage/taskDetail",
        query: {
            activeKey: record.num,
            type: '0',//  0 查看详情模式  ，1编辑模式
            from: "0",  //来源 0 testManage/task  ，1  testManage/reservation
            id: record.id,
        }
    });
};

//获取测试类型字典数据
const testType = ref([]);


onActivated(async () => {
    testType.value = await appStore.getSysDictVOList("测试类型");

    const actKey = +route.query.activeKey;
    console.log("task index onActivated", actKey);
    if (actKey || actKey === 0){
        activeKey.value = actKey;
    }
    getData();
});


</script>
<style lang="less" scoped>
.review {
    padding: 13px 20px 20px 20px;
    height: calc(100vh - 70px - 57px);
    background-color: #ffffff;
}

.inp {
    width: 13.5vw;
}

.query-item {
    display: flex;
    justify-content: space-between;

    .search-l {
        display: flex;
    }

    .search-r {
        display: flex;
    }
}

.modal_item {
    padding: 0 26px 106px 23px;
    background: #F6F8FA;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;

    .file_text {
        padding-top: 19px;
        border-bottom: 1px solid #D4E0F0;

        .fil_it {
            display: flex;
            align-items: center;
            padding-left: 49px;
            padding-bottom: 19px;

            .file_tit {
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #6C7683;
            }

            .file_ic {
                font-size: 14px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                color: #1D2129;
            }
        }

        .file_icon {
            color: rgba(24, 111, 242, 1);
        }
    }


}

.addBtn {
    position: fixed;
    right: 50px;
    top: 93px;
}

.mr10 {
    margin-left: 10px;
}

a {
    color: #1E8EF2;
}

.radio_class {
    font-size: 14px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: rgba(29, 33, 41, 1);
}

.area_class {
    display: flex;
}

.area_width {
    width: calc( 100% - 100px );
    margin-left: 26px;
    // margin-top: 22px;
}

.mt22 {
    margin-top: 22px;
}

.mt32 {
    margin-top: 32px;
}

.mb85 {
    margin-bottom: 85px;
}

.mb26 {
    margin-bottom: 26px;
}

.ml26 {
    margin-left: 26px;
}

.pl30 {
    padding-left: 30px;
}

.pl43 {
    padding-left: 43px;
}

.pl15 {
    padding-left: 15px;
}

.pl55 {
    padding-left: 55px;
}

.pl89 {
    padding-left: 89px;
}

.pl91 {
    padding-left: 91px;
}

/deep/.ant-tabs .ant-tabs-tab {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    margin: 0 0 0 70px;
    color: rgba(29, 33, 41, 0.7);
}

/deep/.ant-tabs .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #1D2129;
}


/deep/.ant-tabs-nav {
    margin-bottom: 24px;
}

/deep/.ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar {
    height: 3px;
    // background: rgba(30, 142, 242, 1);
}

/deep/.ant-upload-wrapper .ant-upload-list {
    width: 130px;
}
</style>
